import React from "react";
import { SelectOption } from "@showitinc/showit-wc";

import LanguageConstants from "../../constants/LanguageConstants";

const LanguageOptions = () => {
  return LanguageConstants.LANGUAGE_OPTIONS.map((language) => (
    <SelectOption key={`si-${language.code}`} value={language.code}>
      {language.label}
      {language.label !== LanguageConstants.UNDETERMINED_LABEL ? ` - ${language.code}` : ""}
    </SelectOption>
  ));
};

export default LanguageOptions;
